module.exports = __webpack_public_path__ + "static/media/dog.f7700133.png";